/**
 * InstanciasConectadasWidget — Quantas instancias WhatsApp estao
 * conectadas / desconectadas.
 */
import React from "react";
import { Link } from "react-router-dom";

import { listarInstancias } from "../../../services/whatsapp";

import { CardBody, KpiValor, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "whatsapp_instancias",
  label: "Instancias WhatsApp",
  descricao: "Instancias conectadas vs desconectadas.",
  categoria: "WhatsApp",
  permissoes: ["whatsapp:atender"],
  tamanho_default: "S",
  essencial: false,
};

export async function fetchData(request) {
  const payload = await listarInstancias(request, { pageSize: 50 });
  const items = Array.isArray(payload) ? payload : (payload?.results || []);
  const conectadas = items.filter((i) => i.status === "CONECTADA").length;
  const total = items.length;
  return { conectadas, total, lista: items.slice(0, 3) };
}

export function Widget({ dados }) {
  const con = dados?.conectadas ?? 0;
  const tot = dados?.total ?? 0;
  return (
    <>
      <CardBody>
        <KpiValor style={{ color: con === tot && tot > 0 ? "var(--success-text)" : "var(--warning-text)" }}>
          {con}/{tot}
        </KpiValor>
        <KpiSub>
          {tot === 0
            ? "Nenhuma instancia cadastrada."
            : con === tot
            ? "Todas conectadas"
            : `${tot - con} desconectada(s)`}
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/whatsapp/instancias">Ver instancias</LinkLight>
      </CardFooter>
    </>
  );
}
